(function () {
  var els = document.querySelectorAll('[data-counter]');
  if (!els.length) return;

  function animate(el) {
    var target = parseInt(el.getAttribute('data-target'), 10) || 0;
    var duration = 1600;
    var start = null;

    // Un fantôme invisible superposé porte la valeur finale : il fixe la largeur
    // exacte du nombre, quelle que soit la police chargée, sans espace résiduel.
    var ghost = el.parentElement && el.parentElement.querySelector('[data-counter-ghost]');
    if (ghost) ghost.textContent = target.toLocaleString('fr-FR');

    function step(timestamp) {
      if (!start) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.floor(eased * target).toLocaleString('fr-FR');
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = target.toLocaleString('fr-FR');
      }
    }

    requestAnimationFrame(step);
  }

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animate(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { observer.observe(el); });
  } else {
    els.forEach(animate);
  }
})();
